import React from "react";
import { Link } from "react-router-dom";
import { useLiveToday, timeLeft } from "@/lib/liveToday";
import { useTier } from "@/lib/ageGroup";
import { track } from "@/lib/track";

const LABEL = { DAILY_CHALLENGE: "Daily Challenge", LIVE_QUEST: "Live Quest", TOURNAMENT: "Tournament" };
const ICON = { DAILY_CHALLENGE: "📅", LIVE_QUEST: "📡", TOURNAMENT: "🏆" };

/** Live Today inside More — only what the canonical registry says is current right now (server clock); nothing hard-coded. */
export default function MoreLiveToday({ onNavigate }) {
  const tier = useTier() || "explorers";
  const { items, data } = useLiveToday(tier);
  const go = (id) => { onNavigate?.(); track("nav_destination_selected", { hub: "live", id, via: "more" }); };
  return (
    <section className="mwq-card p-0 overflow-hidden" data-testid="more-live-today" aria-labelledby="more-live-title">
      <Link to="/live" onClick={() => go("live")} data-testid="more-live-link" className="flex items-center gap-3 min-h-[56px] px-4 py-2 hover:bg-[var(--color-neutral-surface)]">
        <span aria-hidden className="text-xl">⚡</span>
        <span id="more-live-title" className="flex-1 font-extrabold text-[var(--color-text)]">Live Today</span>
        <span aria-hidden className="text-muted-safe">›</span>
      </Link>
      {items.length > 0 && (
        <ul className="border-t-2 border-[var(--color-border)] divide-y divide-[var(--color-border)]" data-testid="more-live-items">
          {items.map((i) => (
            <li key={i.liveActivityId}>
              <Link to={i.route} onClick={() => go(i.liveActivityId)} data-testid={`more-live-${i.type.toLowerCase()}`} className="flex items-center gap-3 min-h-[48px] pl-8 pr-4 py-1.5 hover:bg-[var(--color-neutral-surface)]">
                <span aria-hidden>{ICON[i.type] || "⚡"}</span>
                <span className="flex-1 min-w-0 font-bold text-sm">{LABEL[i.type] || i.title}</span>
                <span className="mwq-meta shrink-0">{i.completed ? "Done ✓" : i.endAt ? timeLeft(i.endAt) : "Open"}</span>
              </Link>
            </li>
          ))}
        </ul>
      )}
      {data && items.length === 0 && <p className="px-4 pb-3 mwq-meta" data-testid="more-live-none">Nothing live right now — come back tomorrow.</p>}
    </section>
  );
}
